import { render, staticRenderFns } from "./learnings-add-subject.vue?vue&type=template&id=3a1ed50f&"
import script from "./learnings-add-subject.vue?vue&type=script&lang=js&"
export * from "./learnings-add-subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports